<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ identificationTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ identificationSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- dni -->
            <div class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input type="text" class="input" maxlength="9" formControlName="dni" id="dni" name="dni" (keyup)="onChangeDni($event)" />
                        <label class="input-label" for="dni">{{ dni | translate }}</label>

                        <div *ngIf="this.formGroup.controls.dni.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoDni | translate }}</span>
                    </div>
                </div>
            </div>

            <!-- expirationNif -->
            <div class="form-row">
                <div class="form-field">
                    <p-calendar
                        id="expirationNif"
                        class="birth-date"
                        type="date"
                        formControlName="expirationNif"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ expirationNifLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    >
                    <!-- <ng-template pTemplate="date" let-date>
                        <span [ngStyle]="{textDecoration: (date.year > 21 && date.day > 10) ? 'line-through' : 'inherit'}">
                            {{date.day}}
                        </span>
                    </ng-template> -->
                    </p-calendar>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
